var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('img',{staticStyle:{"position":"absolute","background-color":"transparent","border-radius":"5px","left":"-.75em"},attrs:{"src":require("../assets/kfe.png"),"height":"46"}})])
}]

export { render, staticRenderFns }